import { setCookie } from '../utils/cookies.js';

// Get the urgent message
var urgent = document.querySelector('.jsUrgentMessage');

// Check for the urgent message
if (urgent)
{
	// Get the close button
	var urgent_close = urgent.querySelector('.jsUrgentClose');

	// Get the CTA button(s)
	var urgent_cta_arr = urgent.querySelectorAll('.jsUrgentCtaWrapper a');

	// When the user clicks on close (x), close the modal
	// The urgent message is hidden for 15 minutes
	if (urgent_close)
	{
		urgent_close.onclick = function ()
		{
			urgent.close();
			setCookie("dismissedUrgentMessage", 1, 1 / 24 / 4);
			document.documentElement.style.setProperty('--urgentMessageHeight', '0px');
			// tell the header-offset module to recalc right now
			if (typeof window.updateHeaderOffset === 'function')
			{
				window.updateHeaderOffset();
			}
		};
	}

	// When the user clicks on any of the CTA buttons, the urgent message is hidden for 7 days
	urgent_cta_arr.forEach(urgent_cta =>
	{
		urgent_cta.onclick = function (event)
		{
			event.preventDefault();
			setCookie("dismissedUrgentMessage", 1, 7);
			// root.style.setProperty('--urgentMessageHeight', '0px');
			window.location.href = urgent_cta.href;
		};
	});
}